export default __webpack_public_path__ + "static/media/loginSimple.5e979b0b.svg";